export const dollar = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
});

export const scoreClothes = (articles) => {
  const selected = articles.filter((article) => article.selected);
  if (selected.length === clothingArticles.length) return 105;
  if (selected.length < 1) return -2;
  if (selected.find((article) => article.id === 'bikini')) return 0;
  if (
    selected.find((article) => article.id === 'cape') &&
    selected.find((article) => article.id === 'crown')
  )
    return 100;

  if (
    selected.find((article) => article.id === 'boxers') &&
    selected.find((article) => article.id === 'tanktop')
  )
    return 103;

  if (
    selected.find((article) => article.id === 'bling') &&
    selected.find((article) => article.id === 'shorts')
  )
    return 102;

  if (
    selected.find((article) => article.id === 'wetsuit') &&
    selected.find((article) => article.id === 'snorkel')
  )
    return 101;

  if (
    selected.length < 2 &&
    (selected.find((article) => article.id === 'hoodie') ||
      selected.find((article) => article.id === 'dress2'))
  )
    return 30;

  if (selected.length < 2 && selected.find((article) => article.id === 'hat'))
    return 104;

  return 75;
};

export const clothingArticles = [
  {
    id: 'wetsuit'
  },
  {
    id: 'boxers'
  },
  {
    id: 'pants3'
  },
  {
    id: 'pants2'
  },
  {
    id: 'pants1'
  },
  {
    id: 'shorts'
  },
  {
    id: 'skirt'
  },
  {
    id: 'tanktop'
  },
  {
    id: 'shirt3'
  },
  {
    id: 'shirt2'
  },
  {
    id: 'dress1'
  },
  {
    id: 'dress2'
  },
  {
    id: 'dress3'
  },
  {
    id: 'belt'
  },
  {
    id: 'hoodie'
  },
  {
    id: 'bikini'
  },
  {
    id: 'cape'
  },
  {
    id: 'balaclava'
  },
  {
    id: 'overalls'
  },
  {
    id: 'jacket'
  },
  {
    id: 'bling'
  },
  {
    id: 'hat2'
  },
  {
    id: 'hat'
  },
  {
    id: 'crown'
  },
  {
    id: 'glasses'
  },
  {
    id: 'snorkel'
  },
  {
    id: 'tie'
  }
];
